// src/components/ListaUrzadzen.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './componenetStyle/ListaUrzadzen.css';
import { useAuth } from '../auth/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

const ListaUrzadzen = () => {
  const { hasAnyPermission } = useAuth();
  const canManageListaUrzadzen = hasAnyPermission(['orders_edit_all', 'warehouse_manage', 'settings_manage']);
  const [devices, setDevices] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [newDevice, setNewDevice] = useState({
    typ: '',
    rodzaj: '',
    nazwa: '',
    model: '',
    interwal_przegladow: '',
    gwarancja: '',
  });
  const [editingDeviceId, setEditingDeviceId] = useState(null);
  const [editDeviceData, setEditDeviceData] = useState({});

  // Pobieranie danych z API
  const fetchDevices = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/lista-urzadzen`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDevices(res.data);
    } catch (error) {
      console.error("Błąd pobierania urządzeń:", error);
    }
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  // Obsługa pola dla dodawania nowego rekordu
  const handleInputChangeNew = (e) => {
    const { name, value } = e.target;
    setNewDevice((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Dodanie nowego urządzenia
  const handleAddDevice = async () => {
    if (!canManageListaUrzadzen) return;
    try {
      const token = localStorage.getItem("token");
      const payload = {
        ...newDevice,
        interwal_przegladow: Number(newDevice.interwal_przegladow),
        gwarancja: Number(newDevice.gwarancja),
      };
      await axios.post(`${API_URL}/lista-urzadzen`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchDevices();
      setNewDevice({
        typ: '',
        rodzaj: '',
        nazwa: '',
        model: '',
        interwal_przegladow: '',
        gwarancja: '',
      });
      setIsAdding(false);
    } catch (error) {
      console.error("Błąd dodawania urządzenia:", error);
      alert("Wystąpił błąd podczas dodawania urządzenia.");
    }
  };

  // Rozpoczęcie trybu edycji dla wybranego urządzenia
  const handleEditClick = (device) => {
    if (!canManageListaUrzadzen) return;
    setEditingDeviceId(device.id_urzadzenie_z_listy);
    setEditDeviceData({
      typ: device.typ,
      rodzaj: device.rodzaj,
      nazwa: device.nazwa,
      model: device.model,
      interwal_przegladow: device.interwal_przegladow,
      gwarancja: device.gwarancja,
    });
  };

  // Aktualizacja wartości w trybie edycji
  const handleInputChangeEdit = (e) => {
    const { name, value } = e.target;
    setEditDeviceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Zapis zmian w trybie edycji
  const handleSaveEdit = async (id) => {
    if (!canManageListaUrzadzen) return;
    try {
      const token = localStorage.getItem("token");
      const payload = {
        ...editDeviceData,
        interwal_przegladow: Number(editDeviceData.interwal_przegladow),
        gwarancja: Number(editDeviceData.gwarancja),
      };
      await axios.put(`${API_URL}/lista-urzadzen/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchDevices();
      setEditingDeviceId(null);
      setEditDeviceData({});
    } catch (error) {
      console.error("Błąd aktualizacji urządzenia:", error);
      alert("Wystąpił błąd podczas aktualizacji urządzenia.");
    }
  };

  const handleCancelEdit = () => {
    setEditingDeviceId(null);
    setEditDeviceData({});
  };

  return (
    <div className="lista-urzadzen-container">
      <div className="header">
        <h2>Lista Urządzeń</h2>
        {canManageListaUrzadzen ? <button className="add-button" onClick={() => setIsAdding(true)}>
          Dodaj nowe
        </button> : null}
      </div>
      <table className="lista-urzadzen-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Typ</th>
            <th>Rodzaj</th>
            <th>Nazwa</th>
            <th>Model</th>
            <th>Interwał przeglądów</th>
            <th>Gwarancja</th>
            <th>Akcje</th>
          </tr>
        </thead>
        <tbody>
          {devices.map((device) => (
            <tr key={device.id_urzadzenie_z_listy}>
              <td>{device.id_urzadzenie_z_listy}</td>
              {editingDeviceId === device.id_urzadzenie_z_listy ? (
                <>
                  <td>
                    <input
                      type="text"
                      name="typ"
                      value={editDeviceData.typ}
                      onChange={handleInputChangeEdit}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="rodzaj"
                      value={editDeviceData.rodzaj}
                      onChange={handleInputChangeEdit}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="nazwa"
                      value={editDeviceData.nazwa}
                      onChange={handleInputChangeEdit}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="model"
                      value={editDeviceData.model}
                      onChange={handleInputChangeEdit}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="interwal_przegladow"
                      value={editDeviceData.interwal_przegladow}
                      onChange={handleInputChangeEdit}
                      required
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      name="gwarancja"
                      value={editDeviceData.gwarancja}
                      onChange={handleInputChangeEdit}
                      required
                    />
                  </td>
                  <td>
                    {canManageListaUrzadzen ? <button onClick={() => handleSaveEdit(device.id_urzadzenie_z_listy)}>
                      Zapisz
                    </button> : null}
                    {canManageListaUrzadzen ? <button onClick={handleCancelEdit}>Anuluj</button> : null}
                  </td>
                </>
              ) : (
                <>
                  <td>{device.typ}</td>
                  <td>{device.rodzaj}</td>
                  <td>{device.nazwa}</td>
                  <td>{device.model}</td>
                  <td>{device.interwal_przegladow}</td>
                  <td>{device.gwarancja}</td>
                  <td>
                    {canManageListaUrzadzen ? <button onClick={() => handleEditClick(device)}>Edytuj</button> : null}
                    {/* Możesz dodać przycisk usuwania, jeśli potrzebujesz */}
                  </td>
                </>
              )}
            </tr>
          ))}
          {isAdding && (
            <tr className="new-device-row">
              <td>Nowy</td>
              <td>
                <input
                  type="text"
                  name="typ"
                  value={newDevice.typ}
                  onChange={handleInputChangeNew}
                  placeholder="Typ"
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="rodzaj"
                  value={newDevice.rodzaj}
                  onChange={handleInputChangeNew}
                  placeholder="Rodzaj"
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="nazwa"
                  value={newDevice.nazwa}
                  onChange={handleInputChangeNew}
                  placeholder="Nazwa"
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  name="model"
                  value={newDevice.model}
                  onChange={handleInputChangeNew}
                  placeholder="Model"
                  required
                />
              </td>
              <td>
                <input
                  type="number"
                  name="interwal_przegladow"
                  value={newDevice.interwal_przegladow}
                  onChange={handleInputChangeNew}
                  placeholder="Interwał przeglądów"
                  required
                />
              </td>
              <td>
                <input
                  type="number"
                  name="gwarancja"
                  value={newDevice.gwarancja}
                  onChange={handleInputChangeNew}
                  placeholder="Gwarancja"
                  required
                />
              </td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
      {isAdding && canManageListaUrzadzen && (
        <div className="new-device-actions">
          <button onClick={handleAddDevice}>Zapisz</button>
          <button onClick={() => {
            setIsAdding(false);
            setNewDevice({
              typ: '',
              rodzaj: '',
              nazwa: '',
              model: '',
              interwal_przegladow: '',
              gwarancja: '',
            });
          }}>
            Anuluj
          </button>
        </div>
      )}
    </div>
  );
};

export default ListaUrzadzen;
